import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { ProjectService, Project } from './project.service';
import { AppSettings } from '../app.settings';

@Injectable()
export class ResolverLbeProjectsService implements Resolve<Project[]> {

	constructor(
		private projectService: ProjectService
	) { }
	async resolve(): Promise<Project[]> {
		const lbeProjects = await this.projectService.getProjectsByApp(AppSettings.lbeAppName);
		return lbeProjects;
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/resolver-lbe-projects.service.ts